import React from 'react';
import './css/Nico.css';
import './css/Styles.css';
import logo from '../public/logo192.png';

const Footer = () => (
  <footer className="footer">
    <small className="footersmall">
      © 2025
      <a target="_blank" href="http://macrosistemassrl.com.ar" rel="noreferrer">
        MacroSistemas S.A.
      </a>
      <img className="imagen_logo" src={logo} height="30px" />
    </small>
    <br />
  </footer>
);

export default Footer;
